import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ANALYTICS_KEY } from 'app/config';
import { WindowService } from '../window.service';

declare const ga: Function;

@Injectable()
export class AnalyticsService {

  private static configurarGA(i, s, o, g, r, a = null, m = null) {
    i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date().getTime(); a = s.createElement(o),
      m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m);
  }

  constructor(private router: Router, private window: WindowService) {
    this.configurar();
    this.router.events.subscribe(event => {
      try {
        if (typeof ga === 'function') {
          if (event instanceof NavigationEnd) {
            ga('set', 'page', event.urlAfterRedirects);
            ga('send', 'pageview');
          }
        }
      } catch (e) {
        console.error(e);
      }
    });
  }

  private configurar() {
    AnalyticsService.configurarGA(
      this.window.nativeWindow,
      this.window.nativeDocument,
      'script',
      'https://www.google-analytics.com/analytics.js',
      'ga',
    );

    ga('create', ANALYTICS_KEY, 'auto');
    ga('send', 'pageview');
  }

  public registrar(eventCategory: string,
    eventAction: string,
    eventLabel: string = null,
    eventValue: number = null) {
    if (typeof ga === 'function') {
      ga('send', 'event', {
        eventCategory,
        eventAction,
        eventLabel,
        eventValue,
      });
    }
  }
}
